import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectBuyPackageModalServices } from '../../../../../../selectors/buyPackageModal';
import { AuctionPointsContainer } from './components/AuctionPoints';
import { GiftsContainer } from './components/Gifts';
import { ServicesContainer } from './components/Services';
import { TableHeaderContainer } from './components/TableHeader';
import { ClassicTableView } from './ClassicTableView';
import { getIsAuctionPointsColAvailable, getIsDurationColAvailable } from './utils';

export const ClassicTableViewContainer = () => {
  const services = useSelector(selectBuyPackageModalServices);

  const isDurationColAvailable = React.useMemo(() => getIsDurationColAvailable(services), [services]);
  const isAuctionPointsColAvailable = React.useMemo(() => getIsAuctionPointsColAvailable(services), [services]);

  return (
    <ClassicTableView>
      <TableHeaderContainer durationCol={isDurationColAvailable} auctionPointsCol={isAuctionPointsColAvailable} />

      <ServicesContainer durationCol={isDurationColAvailable} auctionPointsCol={isAuctionPointsColAvailable} />

      <GiftsContainer durationCol={isDurationColAvailable} auctionPointsCol={isAuctionPointsColAvailable} />

      <AuctionPointsContainer durationCol={isDurationColAvailable} />
    </ClassicTableView>
  );
};
